let runtimeErrorHandler = null;
export function getRuntimeErrorHandler() {
    return runtimeErrorHandler;
}
export function setRuntimeErrorHandler(handler) {
    const previous = runtimeErrorHandler;
    runtimeErrorHandler = handler;
    return () => {
        runtimeErrorHandler = previous;
    };
}
export function reportRuntimeError(kind, error) {
    try {
        runtimeErrorHandler?.({ kind, error });
    }
    catch (handlerError) {
        globalThis.console?.error('[smoothie/ui] Runtime error handler failed', handlerError);
    }
    switch (kind) {
        case 'observer':
            globalThis.console?.error('[smoothie/ui] Runtime observer error', error);
            return;
        case 'flush-listener':
            globalThis.console?.error('[smoothie/ui] Runtime flush-listener error', error);
            return;
        case 'reactive-loop':
            globalThis.console?.error('[smoothie/ui] Reactive update loop detected', error);
            return;
    }
}
//# sourceMappingURL=diagnostics.js.map